import { mainApi } from "../api/root-api"
import { cancelOrder } from "../slices/orderSlice"
import { setError, setSuccess } from "../slices/statusSlice"

export const deleteServiceAction = (id, body, token) => {
  const headers = {headers:{ Authorization: token }, data: body}
  let payload = {}
  return async (dispatch, navigate) => {
    await mainApi.delete(`/services/${id}`, headers).then(resp => {
      payload = {
        message: 'Pedido eliminado con exito',
        status: resp.status
      }  
      dispatch(cancelOrder(id))
    }).catch(err => {
      payload = {
        message: err.response.data.message.error,
        status: err.response.status
      }  
      dispatch( setError(payload) )
    })
  }
}